
$(document).ready(function () {
	// accordion functionality
	var accordion = $('div.accordion');
	if (accordion.length) {
		accordion.find('.accordion-item.active .copy').stop().slideDown(0);
		$('div.accordion .accordion-item .trigger').click(function () {
			var currAcc = $(this).parent().parent().attr('id');
			var currItem = $(this).parent();
			var currCopy = $(this).next('.copy');

			$(currAcc).next('.accordion-item.active').not($(this)).removeClass('active');
			$(currAcc).next('.accordion-item .copy').not(currCopy).stop().slideUp();

			currItem.toggleClass('active');
			currCopy.stop().slideToggle();
		});
	}
  $('.clear-filters.all').click(function () {
    FWP.reset(['case_studies_space_type', 'case_studies_context']);
	});
  $('.clear-filters.space-type').click(function () {
    FWP.reset('case_studies_space_type');
	});
  $('.clear-filters.context').click(function () {
    FWP.reset('case_studies_context');
	});
});
